
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-section-component',
  standalone: true,
  imports: [],
  templateUrl: './section-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './section-component.css',
})
export class SectionComponent {
  @Input() heightSecao: string = '80vh';
}
